import cx from 'classnames'
import { ReactNode, memo, useCallback } from 'react'
import { useEditorView } from '../EditorProvider/hooks/useEditorView'
import { useAutoFocus } from '../hooks/useAutoFocus'
import Styles from './EditorRenderer.module.scss'

interface Props {
  autoFocus?: boolean
}

export const EditorRenderer = memo(({ autoFocus = false }: Props) => {
  const view = useEditorView()
  useAutoFocus(view, autoFocus)

  const editorRef = useCallback(
    (element: HTMLDivElement | null) => {
      if (element) {
        element.appendChild(view.dom)
      }
    },
    [view],
  )

  return <div className={cx(Styles.editorRenderer, 'prosemirror-editor')} ref={editorRef} />
})

export const StylesProvider = ({ children }: { children: ReactNode }) => {
  return <div className={Styles.editorRenderer}>{children}</div>
}
